import { Component } from '@theme/component';

/**
 * Lightweight product-title element.
 * Title truncation is handled by CSS to avoid creating a ResizeObserver for every product card.
 */
class ProductTitle extends Component {}

if (!customElements.get('product-title')) {
  customElements.define('product-title', ProductTitle);
}

export default ProductTitle;
